import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { logOut } from '../services/authService';

interface NavBarProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

const NavBar: React.FC<NavBarProps> = ({ isCollapsed, onToggle }) => {
  const location = useLocation();
  
  const handleSignOut = async () => {
    try {
      console.log('Signing out user');
      await logOut();
      // Redirect handled automatically by App component
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };
  
  return (
    <nav className={`navbar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="navbar-header">
        <div className="navbar-brand">
          <h1>NFI</h1>
          <span>Lumper Receipt</span>
        </div>
        <button className="navbar-toggle" onClick={onToggle} aria-label="Toggle navigation menu">
          <span className="toggle-icon"></span>
        </button>
      </div>
      
      <div className="navbar-content">
        <ul className="navbar-nav">
          <li className={location.pathname === '/' ? 'active' : ''}>
            <Link to="/">
              <span className="nav-icon dashboard-icon"></span>
              <span className="nav-text">Dashboard</span>
            </Link>
          </li>
          <li className={location.pathname === '/receipts' ? 'active' : ''}>
            <Link to="/receipts">
              <span className="nav-icon receipt-icon"></span>
              <span className="nav-text">Receipts</span>
            </Link>
          </li>
          <li className={location.pathname === '/manual-receipt' ? 'active' : ''}>
            <Link to="/manual-receipt">
              <span className="nav-icon create-icon"></span>
              <span className="nav-text">Create Receipt</span>
            </Link>
          </li>
          <li className={location.pathname === '/batch-receipt' ? 'active' : ''}>
            <Link to="/batch-receipt">
              <span className="nav-icon batch-icon"></span>
              <span className="nav-text">Batch Processing</span>
            </Link>
          </li>
          <li className={location.pathname === '/carriers' ? 'active' : ''}>
            <Link to="/carriers">
              <span className="nav-icon carrier-icon"></span>
              <span className="nav-text">Carriers</span>
            </Link>
          </li>
          <li className={location.pathname === '/lanes' ? 'active' : ''}>
            <Link to="/lanes">
              <span className="nav-icon lane-icon"></span>
              <span className="nav-text">Lanes</span>
            </Link>
          </li>
          <li className={location.pathname === '/settings' ? 'active' : ''}>
            <Link to="/settings">
              <span className="nav-icon settings-icon"></span>
              <span className="nav-text">Settings</span>
            </Link>
          </li>
        </ul>
        
        <div className="navbar-footer">
          <button onClick={handleSignOut} className="logout-btn">
            <span className="nav-icon logout-icon"></span>
            <span className="nav-text">Sign Out</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavBar; 